module.exports = __webpack_public_path__ + "static/media/colabs-portfolio_0.dd7cd869.jpg";